import React, { useState } from 'react';
import { teamMembers, TeamMember } from '../data/team';
import { TeamMemberCard } from '../components/TeamMemberCard';
import { TeamMemberModal } from '../components/TeamMemberModal';

const TeamPage: React.FC = () => {
  const [selectedMember, setSelectedMember] = useState<TeamMember | null>(null);

  return (
    <div>
      {/* Page Header */}
      <section className='py-20 md:py-28 text-center bg-muted relative'>
        <div className='absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-30'>
          <div className='absolute -top-24 -left-24 w-96 h-96 rounded-full bg-primary/20 blur-3xl'></div>
          <div className='absolute top-1/2 right-0 w-64 h-64 rounded-full bg-secondary/20 blur-3xl'></div>
        </div>
        <div className='container mx-auto px-6 relative z-10'>
          <p className='text-sm font-bold tracking-widest text-secondary uppercase mb-3 opacity-0 animate-fade-in-up'>
            The People Behind It
          </p>
          <h1 className='text-4xl md:text-6xl font-bold text-foreground font-heading mb-6 opacity-0 animate-fade-in-up'>
            Meet Our <span className='text-primary'>Team</span>
          </h1>
          <p
            className='text-xl text-muted-foreground max-w-3xl mx-auto opacity-0 animate-fade-in-up'
            style={{ animationDelay: '0.2s' }}
          >
            The passionate individuals dedicated to building and supporting our community.
          </p>
        </div>
      </section>

      {/* Meet the Team Section */}
      <section className='py-20'>
        <div className='container mx-auto px-6'>
          <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10'>
            {teamMembers.map((member, index) => (
              <div
                key={member.id}
                className='opacity-0 animate-fade-in-up'
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <TeamMemberCard member={member} onReadMore={() => setSelectedMember(member)} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedMember && <TeamMemberModal member={selectedMember} onClose={() => setSelectedMember(null)} />}
    </div>
  );
};

export default TeamPage;
